import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebook, FaTiktok, FaInstagram } from "react-icons/fa";
import { motion, useAnimation, useInView } from "framer-motion";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContactPage = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Kontakti | Premium Pefume KS";
  }, []);
  const handleOrder = (e) => {
    e.preventDefault();

    const form = e.target;

    emailjs
      .sendForm(
        "service_7biuhua",
        "template_7w8pbxh",
        form,
        "u_41kRZzICRMIjAy6"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Mesazhi u dergua me sukses!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to place order.");
        }
      );
  };
  return (
    <Container>
      <motion.div
        ref={ref}
        className="left"
        animate={{ opacity: 1, x: 0 }}
        initial={{ opacity: 0, x: -200 }}
        transition={{
          duration: 0.7,
          bounce: 0.3,
          delay: 0.4,
          type: "spring",
        }}
      >
        <h1>
          {t("contactTitle")} <br /> {t("contactTitleLine2")}
        </h1>
        <p>
          {t("contactDescription")}
        </p>
        <div className="icons">
          <Link
            to={"https://www.instagram.com/premiumperfumeks/"}
            target="_blank"
          >
            <FaInstagram className="icon insta" />
          </Link>
          <Link to={"https://www.tiktok.com/@premiumperfumeks"} target="_blank">
            <FaTiktok className="icon" />
          </Link>
          {/* <Link to={"https://www.facebook.com/21ditepaakne"} target="_blank">
            <FaFacebook className="icon" />
          </Link> */}
        </div>
      </motion.div>
      <motion.form
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        transition={{
          duration: 0.7,
          delay: 0.8,
        }}
      >
        {/* <h2>Na Kontakto</h2>
        <input type="text" name="name" placeholder="Emri i plotë" required />
        <input
          type="phone"
          name="phoneNumber"
          placeholder="Numri Kontaktues"
          required
        />
        <textarea
          cols="20"
          rows="4"
          name="message"
          placeholder="Mesazhi ose pytja"
          required
        ></textarea>
        <button type="submit">DËRGO</button> */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2934.3033708416688!2d21.15817747538163!3d42.65492621642286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549f81708f8d75%3A0x93d6b167c323bdcd!2sPremium%20Perfume!5e0!3m2!1sen!2s!4v1722722263782!5m2!1sen!2s"
          width="500"
          height="350"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </motion.form>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 8%;
  display: flex;
  justify-content: center;
  gap: 10px;
  font-family: "Montserrat", cursive;
  position: relative;
  .left {
    margin-top: 5%;
    width: 65%;
    z-index: 0;
    h1 {
      font-size: 5.7vw;
      line-height: 1.1em;
      font-weight: 400;
      font-family: "The Seasons", serif;
      color: #ffffff;
    }
    p {
      margin-right: 17%;
      color: #cccccc;
      font-weight: 300;
      margin-top: 1em;
      max-width: 400px;
    }
    .icons {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-top: 10px;
      .icon {
        font-size: 2.5em;
        color: var(--primaryColor);
      }
      .insta {
        font-size: 3em;
      }
    }
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 1em;
    width: 700px;
    padding: 2em;
    z-index: 1;
    h2 {
      font-weight: 300;
      text-align: center;
      margin-bottom: 10px;
    }
    input,
    textarea {
      font-family: "Montserrat", cursive;
      padding: 10px;
      font-size: 16px;
      border: none;
      border-bottom: 1px solid #dfdfdfc1;
      background: none;
      outline: none;
      color: white;
      ::placeholder {
        color: white;
      }
    }
    button {
      margin-top: 1em;
      display: flex;
      align-self: flex-start;
      margin: auto;
      padding: 17px;
      font-size: 18px;
      font-family: "Comfortaa", cursive;
      background: none;
      border: 1px solid #acacac;
      color: #ffffff;
      cursor: pointer;
      transition: 0.4s;
      &:hover {
        background: #ffffff;
        box-shadow: 0 0 14px 2px var(--shadowColor);
        color: #272727;
        border: 1px solid #ffffffc1;
      }
    }
  }
  @media (max-width: 1300px) {
    padding: 4em 7%;
    .left {
      h1 {
        font-size: 3em;
      }
    }
  }
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    .left {
      width: 100%;
      h1 {
        font-size: 3em;
      }
      p {
        text-align: center;
        margin: auto;
      }
    }
    iframe {
      width: 90%;
    }
  }
  @media (max-width: 550px) {
    padding: 6em 6% 4em 6%;
    form {
      width: 100%;
      padding: 10px;
    }
    .left {
      h1 {
        font-size: 3em;
      }
    }
  }
`;

export default ContactPage;
